firebird.controller('meetingBrandingCtrl', [
    '$scope',
    '$stateParams',
    'logService',
    function ($scope, $stateParams, logService) {
        var self = this;
        const logger = logService.createLoggerWithSource('meetingBrandingCtrl');

        self.init = init;

        self.init();

        function init() {
            logger.log('setting marquee screenshot background to: ', $stateParams.background);
            logger.log('setting marquee screenshot logo to: ', $stateParams.logo);

            if ($stateParams.background === 'null') {
                //checking for null because a user without a custom branding record would get
                //'null' back and cause a 'missing image' to be shown
                self.inMeetingBackground = '';
            } else {
                self.inMeetingBackground = $stateParams.background;
            }

            if ($stateParams.logo === 'null') {
                //checking for null because a user without a custom branding record would get
                //'null' back and cause a 'missing image' to be shown
                self.inMeetingLogo = '';
            } else {
                self.inMeetingLogo = $stateParams.logo;
            }

            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
